export default __webpack_public_path__ + "static/media/Image-4.d6222737.png";